import type { Form } from "@/features/forms/models";
import { FIELD_TYPE } from "@/shared/models/legacy-constants";
import { InfoCircleIcon, Label } from "@/shared/ui";

interface ReadOnlyFieldProps {
  healthieField: Form["fields"][number];
}

export const ReadOnlyField = ({ healthieField }: ReadOnlyFieldProps) => {
  switch (healthieField.type) {
    case FIELD_TYPE.READ_ONLY:
      return (
        <div className="flex gap-2 p-0.5">
          <InfoCircleIcon className="mt-1 size-4 shrink-0" />

          <div className="text-neutral-950">
            <Label htmlFor={healthieField.id} className="font-semibold">
              {healthieField.label}
            </Label>
            <div id={healthieField.id}>
              {healthieField.options.map((text) => text)}
            </div>
          </div>
        </div>
      );

    // TODO: Add field when added in the BE
    case FIELD_TYPE.READ_ONLY_LINK:
      return null;
  }
};
